<template>
    <el-scrollbar>
        <div class="view-modal window-scorll">
          <div :class="[$style.GeminiScrollbar, 'mb-10']">
            <GeminiScrollbar :class="$style['my-scroll-bar']">
                <ul>
                  <li>000001</li>
                  <li>000002</li>
                  <li>000003</li>
                  <li>000004</li>
                  <li>000005</li>
                  <li>000006</li>
                  <li>000007</li>
                  <li>000008</li>
                  <li>000009</li>
                  <li>000010</li>
                  <li>000011</li>
                  <li>000012</li>
                  <li>000013</li>
                  <li>000014</li>
                  <li>000015</li>
                  <li>000016</li>
                  <li>000017</li>
                  <li>000018</li>
                  <li>000019</li>
                  <li>000020</li>
                </ul>
            </GeminiScrollbar>
          </div>
          <div :class="[$style['my-scroll-bar'], 'mb-10']">
            <vuescroll :ops="ops1" ref="vs"
                @handle-resize="handleResize"
                @handle-scroll="handleScroll"
                @handle-scroll-complete="handleComplete">
                <ul id="id1">
                  <li>0001 id1</li>
                  <li>0002 id1</li>
                  <li>0003 id1</li>
                  <li>0004 id1</li>
                  <li>0005 id1</li>
                  <li>0006 id1</li>
                  <li>0007 id1</li>
                  <li>0008 id1</li>
                  <li>0009 id1</li>
                  <li>0010 id1</li>
                  <li>0011 id1</li>
                  <li>0012 id1</li>
                  <li>0013 id1</li>
                  <li>0014 id1</li>
                  <li>0015 id1</li>
                  <li>0016 id1</li>
                  <li>0017 id1</li>
                  <li>0018 id1</li>
                  <li>0019 id1</li>
                  <li>0020 id1</li>
                </ul>
                <ul id="id2">
                  <li>0001 id2</li>
                  <li>0002 id2</li>
                  <li>0003 id2</li>
                  <li>0004 id2</li>
                  <li>0005 id2</li>
                  <li>0006 id2</li>
                  <li>0007 id2</li>
                  <li>0008 id2</li>
                  <li>0009 id2</li>
                  <li>0010 id2</li>
                  <li>0011 id2</li>
                  <li>0012 id2</li>
                  <li>0013 id2</li>
                  <li>0014 id2</li>
                  <li>0015 id2</li>
                  <li>0016 id2</li>
                  <li>0017 id2</li>
                  <li>0018 id2</li>
                  <li>0019 id2</li>
                  <li>0020 id2</li>
                </ul>
            </vuescroll>
          </div>
          <div :class="[$style['my-scroll-bar'], 'mb-10']">
            <vuescroll :ops="ops2" ref="vs-s"
                @refresh-activate="refreshActivate"
                @refresh-start="refreshStart"
                @refresh-before-deactivate="refreshBeforeDeactivate"
                @refresh-deactivate="refreshDeactivate">
                <div class="slot-load" slot="refresh-start" style="position:absolute;">
                  <i class="el-icon-loading"></i>
                </div>
                <div class="child">
                  <ul>
                    <li>0001</li>
                    <li>0002</li>
                    <li>0003</li>
                    <li>0004</li>
                    <li>0005</li>
                    <li>0006</li>
                    <li>0007</li>
                    <li>0008</li>
                    <li>0009</li>
                    <li>0010</li>
                    <li>0011</li>
                    <li>0012</li>
                    <li>0013</li>
                    <li>0014</li>
                    <li>0015</li>
                    <li>0016</li>
                    <li>0017</li>
                    <li>0018</li>
                    <li>0019</li>
                    <li>0020</li>
                  </ul>
                </div>
            </vuescroll>
          </div>
        </div>
    </el-scrollbar>
</template>
 
<script>
//https://vuescrolljs.yvescoding.org/zh/guide/
import vuescroll from 'vuescroll';
export default{
  data(){
    return {
      // aa:[],
      // b:[],
      ops1: {
        vuescroll: {
          mode: 'native',//选择一个模式, native 或者 slide
          sizeStrategy: 'percent',//如果父容器不是固定高度，请设置为 number , 否则保持默认的percent即可
          detectResize: true,//是否检测内容尺寸发生变化
          wheelScrollDuration:0,//滚轮滚动一段距离所需时间。
        },
        scrollPanel: {
          initialScrollY: false,//只要组件mounted之后自动滚动的距离。 例如 100 or 10%
          initialScrollX: false,//只要组件mounted之后自动滚动的距离。 例如 100 or 10%
          scrollingX: true,//是否启用 x 或者 y 方向上的滚动
          scrollingY: true,//是否启用 x 或者 y 方向上的滚动
          speed: 300,//多长时间内完成一次滚动。 数值越小滚动的速度越快
          easing: undefined,//滚动动画 easeInQuad | easeOutQuad | easeInOutQuad | easeInCubic | easeOutCubic | easeInOutCubic | easeInQuart | easeOutQuart | easeInOutQuart | easeInQuint | easeOutQuint | easeInOutQuint
          verticalNativeBarPos: 'right',//原生滚动条的位置
        },
        rail: {
          background: '#01a99a',//轨道的背景色
          opacity: 0,//轨道的透明度
          size: '6px',//轨道的尺寸
          specifyBorderRadius: false,//是否指定轨道的 borderRadius， 如果不那么将会自动设置
          gutterOfEnds: null,//轨道距 x 和 y 轴两端的距离
          gutterOfSide: '2px',//距离容器的距离
          keepShow: false,//是否即使 bar 不存在的情况下也保持显示
          border:'none',//轨道的边框
        },
        bar: {
          showDelay: 500,//在鼠标离开容器后多长时间隐藏滚动条
          onlyShowBarOnScroll: true,//是否只在滚动时显示 bar
          keepShow: true,//滚动条是否保持显示
          background: '#c1c1c1',//滚动条背景色
          opacity: 1,//滚动条透明度
          hoverStyle: true,
          specifyBorderRadius: false,//是否指定滚动条的 borderRadius， 如果不那么和轨道的保持一致
          minSize: false,//为 bar 设置一个最小尺寸, 从 0 到 1. 如 0.3, 代表 30%
          size: '6px',//bar 的尺寸
          disable: false,//是否禁用滚动条
        },
        scrollButton: {
          enable: true,//是否启用 scrollButton
          background: '#c1c1c1',//scrollButton 的背景色
          opacity: 1,//scrollButton 的透明度
          step: 10,//每次当你点击 scrollButton 所滚动的距离
          mousedownStep: 30,//每次当你按住 scrollButton 所滚动的距离
        },
      },
      ops2:{
        vuescroll: {
          mode: 'slide',
          sizeStrategy: 'percent',
          detectResize: true,
          wheelScrollDuration:0,
          pullRefresh: { //下拉刷新 --- 默认配置
            enable: false,
            tips: {
              deactive: 'Pull to Refresh',
              active: 'Release to Refresh',
              start: 'Refreshing...',
              beforeDeactive: 'Refresh Successfully!'
            }
          },
          pushLoad: { //上拉刷新 --- 默认配置
            enable: false,
            tips: {
              deactive: 'Push to Load',
              active: 'Release to Load',
              start: 'Loading...',
              beforeDeactive: 'Load Successfully!'
            },
            auto: false,//是否自动触发加载
            autoLoadDistance: 0//距离底部触发自动加载的距离
          },
          paging: false,
          zooming: true,
          snapping: {
            enable: false,
            width: 100,
            height: 100
          },
          scroller: {
            //允许滚动出边界true或false或数组指定可以是哪个方向反弹。选项可以是['top','bottom','left','right']
            bouncing: {
              top: 100,
              bottom: 100,
              left: 100,
              right: 100
            },
            locking: true,//如果用户在开始时仅在其中一个轴上轻微移动，则启用对主轴的锁定
            minZoom: 0.5,//最小缩放级别
            maxZoom: 3,//最大缩放级别
            speedMultiplier: 1,//增加或减少滚动速度
            penetrationDeceleration: 0.03,//这配置了到达边界时应用于减速的更改量
            penetrationAcceleration: 0.08,//这配置了到达边界时施加于加速度的变化量
            preventDefault: true,//调用e.preventDefault时是否阻止默认事件
            preventDefaultOnMove: true,//当(鼠标/触摸)移动时是否调用preventDefault
            disable: false//是否禁用滚动块
          }
        },
      }
    }
  },
  components:{
    vuescroll
  },
  created(){
    this.$parent.routerLoading();
  },
  methods:{
    handleResize(vertical, horizontal, nativeEvent) {
      //当内容尺寸发生变化时触发
      //给你传递 3 个参数, vertical 和 horizontal 告诉你管你垂直和水平滚动条的信息。第三个参数是触发滚动的原生事件。
      // console.log('内容尺寸发生变化!')
    },
    handleScroll(vertical, horizontal, nativeEvent) {
      //当内容滚动的回收触发
      //给你传递 3 个参数, vertical 和 horizontal 告诉你管你垂直和水平滚动条的信息。第三个参数是触发滚动的原生事件
      // console.log(vertical, horizontal, nativeEvent)
    },
    handleComplete(vertical, horizontal){
      //当滚动结束的时候触发
      //给你传递 2 个参数, vertical 和 horizontal 告诉你管你垂直和水平滚动条的信息
      // console.log('滚动结束！')
    },

    refreshActivate(vm, refreshDom){
      //vm 是当前 vuescroll 实例, refreshDom 是提示的那个 dom
      // console.log(vm, refreshDom)
    },
    refreshStart(vm, refreshDom, done){
      //vm 是当前 vuescroll 实例, refreshDom 是提示的那个 dom。done 是完成函数, 这个阶段你适合去抓取数据, 然后调用 done() 并且进入下一个阶段
      // console.log(vm, refreshDom, done)
    },
    refreshBeforeDeactivate(vm, refreshDom, done){
      //vm 是当前 vuescroll 实例, refreshDom 是提示的那个 dom。done 是完成函数, 这个阶段你适合去给出提示(比如加载成功！或加载失败！), 然后调用 done() 并且进入下一个阶段
      // console.log(vm, refreshDom, done)
    },
    refreshDeactivate(vm, refreshDom){
      // console.log(vm, refreshDom)
    }
  },
  mounted(){
    /*native*/
    // this.$refs['vs'].scrollTo({y: '50%'},500)//滚动到某一个位置，可以只指定x 或 y。 easing
    // this.$refs['vs'].scrollBy({dy: '50%'},500)//以当前位置为起点，滚动一段距离，dx 或 dy。 easing
    // console.log(this.$refs['vs'].getCurrentviewDom())//获取你能看到的 vuescroll 的直接子元素
    // this.$refs['vs'].scrollIntoView('#id2', 500);//当前窗口滚动至vuescroll的一个直接子元素
    // this.$refs['vs'].refresh();//刷新制定 vuescroll 的状态
    // vuescroll.refreshAll();//刷新制定所有 vuescroll 的状态。
    /*Slide*/
    // this.$refs['vs-s'].goToPage({x: 1,y: 2}, true);
    // const pageInfo = this.$refs['vs-s'].getCurrentPage();//获取当前的页码。只在slide模式 和 paging 启动下工作
    // console.log(pageInfo);
    // this.$refs['vs-s'].triggerRefreshOrLoad('load');//直接触发刷新或者加载
  }
}
</script> 
<style module>
.GeminiScrollbar{
  width: 100%;
  height: 100%;
}
.my-scroll-bar{
    height:200px;
    overflow: hidden;
}
</style>
<style>
  
/* override gemini-scrollbar default styles */

/* vertical scrollbar track */
.gm-scrollbar.-vertical {
  background-color: #f0f0f0
}

/* horizontal scrollbar track */
.gm-scrollbar.-horizontal {
  background-color: transparent;
}

/* scrollbar thumb */
.gm-scrollbar .thumb {
  background-color: rebeccapurple;
}
.gm-scrollbar .thumb:hover {
  background-color: fuchsia;
}
</style>


// WEBPACK FOOTER //
// src/components/main-content/vue-scrollbar.vue